// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum POST_OUTLINE_MUTATION_TYPE {
    createChapter = 'create-chapter',
    renameChapter = 'rename-chapter',
    updateChapterDescription = 'update-chapter-description',
    moveChapter = 'move-chapter',
    deleteChapter = 'delete-chapter',
    createSection = 'create-section',
    renameSection = 'rename-section',
    moveSection = 'move-section',
    deleteSection = 'delete-section',
}
